import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { Edit } from 'lucide-react';

import Lottie from 'lottie-react';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import PanelDev from 'panels/dev/PanelDev';

import ServiceOutlet from 'services/serviceOutlet';

import PaneStaff from '../panes/PaneStaff';
import PaneMenu from '../panes/PaneMenu';
import PaneTable from '../panes/PaneTable';
import PaneRoomType from '../panes/PaneRoomType';
import PaneRoom from '../panes/PaneRoom';
import PaneHostel from '../panes/PaneHostel';

import ServiceSubs from 'services/serviceSubs';

import animPage from 'assets/anim/anim-pageload.json';
import animBtnLoading from 'assets/anim/anim-btnLoading.json';
import PaneRental from '../panes/PaneRental';

export default function SubPanelOutletInfo(props) {

    const [loading, setLoading] = useState(true);

    const [doc, setDoc] = useState({});
    const [sub, setSub] = useState({});

    const [tab, setTab] = useState('A');
    const [intoTab, setIntoTab] = useState('outlet');

    const [isOpen, setIsOpen] = useState(false);
    const [submit, setSubmit] = useState(false);

    const outletService = new ServiceOutlet();
    const subsService = new ServiceSubs();

    const taxTypes = [
        { value: 'na', label: 'NA' },
        { value: 'inclusive', label: 'Inclusive' },
        { value: 'exclusive', label: 'Exclusive' },
        { value: 'overall', label: 'Overall' },
    ];

    const formVSchema = Yup.object().shape({
        gstn: Yup.string().required('This information is required'),
        floating: Yup.number().required('This information is required'),
        currency: Yup.string().required('This information is required'),
        foodp: Yup.number().required('This information is required'),
        roomp: Yup.number().required('This information is required'),
        foodptype: Yup.string().required('This information is required'),
        roomptype: Yup.string().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            gstn: '',
            floating: '',
            currency: '',
            foodp: '',
            roomp: '',
            foodptype: '',
            roomptype: '',
        },
        validationSchema: formVSchema,
        enableReinitialize: true,
        onSubmit: values => {
            setSubmit(true);
            let body = {
                uid: doc._id,
                data: {
                    "tax": {
                        isGST: doc.tax.isGST,
                        floatingPoint: values.floating,
                        GSTN: values.gstn,
                        Currency: values.currency,
                        Food_Percentage: values.foodp,
                        Food_TAX_TYPE: values.foodptype,
                        Room_Percentage: values.roomp,
                        Room_TAX_TYPE: values.roomptype,
                    },
                }
            }
            outletService.updateOutletById(body, props.org).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("Tax Settings Updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsOpen(false);
                    loadData();
                    handleReset();
                    resetForm();
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });

        }
    });

    const loadData = () => {
        setLoading(true);
        (async function () {
            setTab('A');
            setIntoTab('outlet');
            var res = await outletService.getOutletById({ 'outletid': props.cid }, props.org);
            setDoc(res.data);

            var resSub = await subsService.getSubByFilter({ 'subid': res.data.subid });
            setSub(resSub.data);

            setLoading(false);
        })();
    }

    const editTaxSettings = () => {
        setValues({
            gstn: doc.tax.GSTN,
            floating: doc.tax.floatingPoint,
            currency: doc.tax.Currency,
            foodp: doc.tax.Food_Percentage,
            roomp: doc.tax.Room_Percentage,
            foodptype: doc.tax.Food_TAX_TYPE,
            roomptype: doc.tax.Room_TAX_TYPE,
        })
        setIsOpen(true);
    }

    useEffect(() => {
        loadData();
    }, [props.cid]);

    return (
        <>
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>UPDATE TAX SETTINGS</h1>
                                    <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                        setIsOpen(false);
                                        resetForm();
                                        loadData();
                                    }}>
                                        <span><i className="las la-times text-xl cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <form className='mt-4 grid grid-cols-12 gap-3' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Tax Cert Number:<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="gstn" value={values.gstn} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxx" onChange={handleChange} />
                                        {(errors.gstn && touched.gstn) && <p className='text-xs text-red-400 mt-1'>{errors.gstn}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Floating Point:<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="floating" value={values.floating} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxx" onChange={handleChange} />
                                        {(errors.floating && touched.floating) && <p className='text-xs text-red-400 mt-1'>{errors.floating}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Currency Symbol:<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="currency" value={values.currency} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. x" onChange={handleChange} />
                                        {(errors.currency && touched.currency) && <p className='text-xs text-red-400 mt-1'>{errors.currency}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Food Tax Percentage (%):<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="foodp" value={values.foodp} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxx" onChange={handleChange} />
                                        {(errors.foodp && touched.foodp) && <p className='text-xs text-red-400 mt-1'>{errors.foodp}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Food Tax Type<sup className="text-red-600">*</sup></label>
                                        <select id="foodptype" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.foodptype}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            {
                                                taxTypes.length !== 0 && taxTypes.map((item) => {
                                                    return <option value={item.value} selected={values.foodptype == item.value}>{item.label}</option>
                                                })
                                            }
                                        </select>
                                        {(errors.foodptype && touched.foodptype) && <p className='text-xs text-red-400 mt-1'>{errors.foodptype}</p>}
                                    </div>

                                    <div className="col-span-4"></div>

                                    {
                                        sub.features.isRoom && <div className="col-span-4">
                                            <label className="block mb-2 text-sm font-medium text-gray-600">Room Tax Percentage (%):<sup className="text-red-600">*</sup></label>
                                            <input type="number" id="roomp" value={values.roomp} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxx" onChange={handleChange} />
                                            {(errors.roomp && touched.roomp) && <p className='text-xs text-red-400 mt-1'>{errors.roomp}</p>}
                                        </div>

                                    }

                                    {
                                        sub.features.isRoom && <div className="col-span-4">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Room Tax Type<sup className="text-red-600">*</sup></label>
                                            <select id="roomptype" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.roomptype}>
                                                <option value="" disabled="" selected="selected">Select</option>
                                                {
                                                    taxTypes.length !== 0 && taxTypes.map((item) => {
                                                        return <option value={item.value} selected={values.roomptype == item.value}>{item.label}</option>
                                                    })
                                                }
                                            </select>
                                            {(errors.roomptype && touched.roomptype) && <p className='text-xs text-red-400 mt-1'>{errors.roomptype}</p>}
                                        </div>
                                    }

                                    <div className='col-span-12 my-6'>
                                        <div className='flex items-end'>
                                            <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                                {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                                {!submit && "SAVE"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            <div>
                {
                    loading && <div className='flex items-center justify-center w-full h-screen'>
                        <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                    </div>
                }
                {
                    !loading && <div>
                        <div className='h-[320px] bg-red-50 px-4 relative'>
                            <div className='h-[220px] bg-prime rounded-b-md'></div>
                            <div className='w-[180px] h-[180px] bg-white border-[6px] border-red-50 rounded-full absolute top-[120px] ml-8'>
                                <div alt='Profile Image' className='w-full h-full rounded-full border-2 border-blue-600 flex items-center justify-center'>
                                    <span className='text-8xl font-medium'>{doc.name[0]}</span>
                                </div>
                            </div>
                            <h1 className='ml-[220px] text-4xl font-medium absolute'>{doc.name}</h1>
                        </div>
                        <div className='bg-gray-50 px-12 py-4'>
                            <div className='bg-white w-full shadow rounded-md p-4 flex'>
                                <div className='w-[30%]'>
                                    <h2 className='text-xl font-medium'>About</h2>
                                    <ul className='mt-2 space-y-2'>
                                        <li className={`text-sm font-medium py-1 px-2 rounded-md cursor-pointer ${intoTab === "outlet" ? "text-red-600 bg-red-50 hover:bg-red-50" : ""}`} onClick={() => { setIntoTab('outlet') }}>Outlet Information</li>
                                        {sub.features.isTax && <li className={`text-sm font-medium py-1 px-2 rounded-md cursor-pointer ${intoTab === "tax" ? "text-red-600 bg-red-50 hover:bg-red-50" : "hover:bg-red-50 hover:text-red-600"}`} onClick={() => { setIntoTab('tax') }}>Tax Information</li>}
                                    </ul>
                                </div>
                                <div className='w-[1px] bg-gray-200 mx-2'></div>
                                {
                                    (() => {
                                        switch (intoTab) {
                                            case 'outlet':
                                                return <div className='flex-grow'>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Trade Names</div>
                                                        <div className="text-slate-950 text-sm font-medium">{doc.name}</div>
                                                        <div className="text-slate-950 text-sm font-medium">{doc.tradNme}</div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Title</div>
                                                        <div className="text-slate-950 text-sm font-medium">{doc.title}</div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Email Address</div>
                                                        <div className="text-slate-950 text-sm font-medium">{doc.email}</div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Email Address</div>
                                                        <div className="text-slate-950 text-sm font-medium">{doc.email}</div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Phone Number</div>
                                                        <div className="text-slate-950 text-sm font-medium">{`+91 ${doc.phone}`}</div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Physical Address</div>
                                                        <div className="text-slate-950 text-sm font-medium">{doc.addresses.length === 0 ? '-' : `${doc.addresses[0].street_1}, ${doc.addresses[0].street_2} ${doc.addresses[0].city}, ${doc.addresses[0].state}, ${doc.addresses[0].country} - ${doc.addresses[0].postal_code}`}</div>
                                                    </div>
                                                </div>
                                            case 'tax':
                                                return <div className='flex-grow'>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Tax Type</div>
                                                        <div className="text-slate-950 text-sm font-medium">Is Taxable: {doc.tax.isGST ? "Yes" : "No"}</div>
                                                        <div className="text-slate-950 text-sm font-medium">Tax cert number: {doc.tax.GSTN}</div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Food Tax</div>
                                                        <div className="text-slate-950 text-sm font-medium uppercase">Tax Type: {doc.tax.Food_TAX_TYPE}</div>
                                                        <div className="text-slate-950 text-sm font-medium">Percentage Tax (%): {doc.tax.Food_Percentage}</div>
                                                    </div>
                                                    {
                                                        sub.features.isRoom && <div className='p-2'>
                                                            <div className="text-slate-400 text-xs font-normal">Room Tax</div>
                                                            <div className="text-slate-950 text-sm font-medium uppercase">Tax Type: {doc.tax.Room_TAX_TYPE}</div>
                                                            <div className="text-slate-950 text-sm font-medium">Percentage Tax (%): {doc.tax.Room_Percentage}</div>
                                                        </div>
                                                    }
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal">Tax Settings</div>
                                                        <div className="text-slate-950 text-sm font-medium">Floating Point: {parseFloat("0.00").toFixed(doc.tax.floatingPoint)}</div>
                                                        <div className="text-slate-950 text-sm font-medium">Currency Symbol: ({doc.tax.Currency})</div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className="text-slate-400 text-xs font-normal flex">Edit Settings: <span><Edit size={14} className='text-blue-600 ml-1 cursor-pointer' onClick={() => { editTaxSettings(); }} /></span></div>
                                                    </div>
                                                </div>
                                        }
                                    })()
                                }
                            </div>
                            <div className='bg-white w-full shadow rounded-md p-4 mt-4'>
                                <h2 className='text-xl font-medium'>Reports</h2>
                                <div class="w-full mt-2">
                                    <div className="py-2 mt-2">
                                        <ul className="intro-y flex text-sm font-sans text-gray-600 border-b">
                                            <li className="mx-2"><button className={`py-2 px-2 ${tab === 'A' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('A') }}>Staff</button></li>
                                            <li className="mx-2"><button className={`py-2 px-2 ${tab === 'B' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('B') }}>Menu</button></li>
                                            {doc.terminaltype === "standard" && <li className="mx-2"><button className={`py-2 px-2 ${tab === 'C' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('C') }}>Table</button></li>}
                                            {sub.features.isRoom && <li className="mx-2"><button className={`py-2 px-2 ${tab === 'D' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('D') }}>Room Type</button></li>}
                                            {sub.features.isRoom && <li className="mx-2"><button className={`py-2 px-2 ${tab === 'E' ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab('E') }}>Room</button></li>}
                                            {sub.apps.includes("APP00002") && <li className="mx-2"><button className={`py-2 px-2 ${tab === "APP00002" ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab("APP00002") }}>Hostel Setup</button></li>}
                                            {sub.apps.includes("APP00004") && <li className="mx-2"><button className={`py-2 px-2 ${tab === "APP00004" ? 'text-blue-600 font-semibold border-b-2 border-blue-600 hover:text-blue-500' : 'bg-white hover:bg-blue-100 rounded-md'}`} onClick={() => { setTab("APP00004") }}>Rentals</button></li>}
                                        </ul>
                                    </div>
                                </div>
                                {
                                    (() => {
                                        switch (tab) {
                                            case 'A':
                                                return (<PaneStaff outlet={doc} sub={sub} />);
                                            case 'B':
                                                return (<PaneMenu outlet={doc} sub={sub} />);
                                            case 'C':
                                                return (<PaneTable outlet={doc} sub={sub} />);
                                            case 'D':
                                                return (<PaneRoomType outlet={doc} sub={sub} />);
                                            case 'E':
                                                return (<PaneRoom outlet={doc} sub={sub} />);
                                            case 'APP00002':
                                                return (<PaneHostel outlet={doc} sub={sub} />);
                                            case 'APP00004':
                                                return (<PaneRental outlet={doc} sub={sub} />);
                                            default:
                                                return (<PanelDev />);
                                        }
                                    })()
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}
